import { useEffect, useState } from 'react';

import { Box, LinearProgress, Typography } from '@mui/material';

import logo from '@assets/logo.svg';

// Simulated bootstrap steps shown while the initial private loader resolves the
// selected client. The last step holds (progress caps below 100%) until the real
// loaders finish and the router unmounts the splash.
const STEPS = [
  { label: 'Встановлюємо з’єднання…', progress: 10 },
  { label: 'Перевіряємо доступ…', progress: 22 },
  { label: 'Завантажуємо ваш профіль…', progress: 36 },
  { label: 'Отримуємо список клієнтів…', progress: 52 },
  { label: 'Синхронізуємо налаштування…', progress: 66 },
  { label: 'Готуємо дані до роботи…', progress: 80 },
  { label: 'Наводимо останні штрихи…', progress: 90 },
  { label: 'Майже готово…', progress: 95 },
];

const STEP_INTERVAL_MS = 1000;

export const AppSplash = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setStepIndex((current) => Math.min(current + 1, STEPS.length - 1));
    }, STEP_INTERVAL_MS);

    return () => clearInterval(timer);
  }, []); // run once — drives the simulated progress independently of the loaders

  const step = STEPS[stepIndex];

  if (!step) return null;

  return (
    <Box
      minHeight="100dvh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={5}
    >
      <img src={logo} alt="Okko" width={172} height={40} />

      <Box width={280} display="flex" flexDirection="column" gap={1.5}>
        <LinearProgress variant="determinate" value={step.progress} />
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {step.label}
        </Typography>
      </Box>
    </Box>
  );
};
